export default __webpack_public_path__ + "static/media/chevron-white.7f81672e.svg";